// ---- Product Image Mapping ----
var productImages = {
  "Coca Cola": "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Cola.png?v=1766446998",
  "Fanta": "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Fanta.png?v=1766446998",
  "Red Bull": "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Red_Bull.png?v=1766446998",
  "Spa Blauw": "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Spa_blauw_flesje.png?v=1766446997",
  "Spa Rood": "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Spa_rood.png?v=1766446998",
  "Koffie": "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Koffie.png?v=1766446997",
  "Coffee": "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Koffie.png?v=1766446997",
  "Mueslireep": "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Mueslireep.png?v=1766446998",
  "Muesli bar": "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Mueslireep.png?v=1766446998",
  "Prote\u00EFnereep": "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Proteine_bar.png?v=1766446998",
  "Protein bar": "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Proteine_bar.png?v=1766446998",
  "Koekjes": "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Koekjes.png?v=1766446998",
  "Cookies": "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Koekjes.png?v=1766446998",
  "Chips (Naturel)": "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Chips_Naturel.png?v=1766446998",
  "Chips Naturel": "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Chips_Naturel.png?v=1766446998",
  "Chips (Paprika)": "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Chips_Paprika.png?v=1766446998",
  "Chips Paprika": "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Chips_Paprika.png?v=1766446998",
  "Sportlife Kauwgom": "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Sportlife_kauwgom.png?v=1766446998",
  "Gum Sportlife": "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Sportlife_kauwgom.png?v=1766446998",
  "Kauwgom Sportlife": "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Sportlife_kauwgom.png?v=1766446998"
};

  // ---- Config (injected by section) ----
  var URBIXX_BOOKING_CONFIG = (function() {
    try {
      var el = document.getElementById("urbixx-booking-config");
      if (!el) return {};
      var raw = (el.textContent || el.innerText || "").trim();
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (e) {
      return {};
    }
  })();
  try { window.URBIXX_BOOKING_CONFIG = URBIXX_BOOKING_CONFIG; } catch (e0) {}

  // ---- Route map logic ----
  var urbixxMap;
  var urbixxDirectionsService;
  var urbixxDirectionsRenderer;
  var lastRouteSummaryText = "";
  var urbixxRouteRunnerMarker = null;
  var urbixxRouteFinishMarker = null; // finish flag (shown at end)
  var urbixxRoutePickupMarker = null;
  var urbixxRouteDropoffMarker = null;
  var urbixxRouteGlowPolyline = null;
  var urbixxRouteMainPolyline = null;
  var urbixxRouteAnimRaf = 0;
  var urbixxRouteOverlay = null;
  var urbixxOverlayView = null;
  var urbixxRouteFollowTimer = 0;
  var urbixxLastRouteResult = null;
  var URBIXX_TRACKING_ICON_URL =
    (URBIXX_BOOKING_CONFIG && URBIXX_BOOKING_CONFIG.trackingIconUrl)
      ? URBIXX_BOOKING_CONFIG.trackingIconUrl
      : "https://cdn.shopify.com/s/files/1/1000/3755/8536/files/Urbixx_Tracking_icon_f517221b-5842-4d6b-929d-45fb17592ee1.png?v=1766853912";
  var urbixxRunnerEl = null;
  var urbixxRunnerAngle = 0;

  function urbixxPrefersReducedMotion() {
    try {
      return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    } catch (e) {
      return false;
    }
  }

  function urbixxEnsureRouteOverlay(mapEl) {
    try {
      if (!mapEl || !urbixxMap) return null;
      if (urbixxRouteOverlay && urbixxRouteOverlay.parentNode) return urbixxRouteOverlay;

      if (!urbixxOverlayView) {
        urbixxOverlayView = new google.maps.OverlayView();
        urbixxOverlayView.onAdd = function() {
          try {
            this._root = document.createElement("div");
            this._root.className = "urbixx-route-overlay";
            this._root.style.position = "absolute";
            this._root.style.left = "0";
            this._root.style.top = "0";
            this._root.style.width = "100%";
            this._root.style.height = "100%";
            this._root.style.pointerEvents = "none";
            var panes = this.getPanes && this.getPanes();
            // floatPane sits above markers/polylines (best for runner + confetti)
            if (panes && panes.floatPane) panes.floatPane.appendChild(this._root);
            urbixxRouteOverlay = this._root;
          } catch (e) {}
        };
        urbixxOverlayView.draw = function() {};
        urbixxOverlayView.onRemove = function() {
          try {
            if (this._root && this._root.parentNode) this._root.parentNode.removeChild(this._root);
          } catch (e) {}
          if (urbixxRouteOverlay === this._root) urbixxRouteOverlay = null;
          this._root = null;
        };
        urbixxOverlayView.setMap(urbixxMap);
      } else {
        // ensure overlay is attached
        try {
          if (!urbixxRouteOverlay && urbixxOverlayView.getPanes) {
            var panes2 = urbixxOverlayView.getPanes();
            if (panes2 && panes2.floatPane) {
              var el2 = document.createElement("div");
              el2.className = "urbixx-route-overlay";
              el2.style.position = "absolute";
              el2.style.left = "0";
              el2.style.top = "0";
              el2.style.width = "100%";
              el2.style.height = "100%";
              el2.style.pointerEvents = "none";
              panes2.floatPane.appendChild(el2);
              urbixxRouteOverlay = el2;
            }
          }
        } catch (e2) {}
      }

      return urbixxRouteOverlay;
    } catch (e3) {
      return null;
    }
  }

  function urbixxClearRouteOverlay() {
    try {
      if (urbixxRouteOverlay) urbixxRouteOverlay.innerHTML = "";
    } catch (e) {}
  }

  function urbixxCancelRouteAnimation(opts) {
    opts = opts || {};
    var keepRoute = !!opts.keepRoute;
    try {
      if (urbixxRouteAnimRaf) cancelAnimationFrame(urbixxRouteAnimRaf);
    } catch (e) {}
    urbixxRouteAnimRaf = 0;
    try {
      if (urbixxRouteFollowTimer) clearInterval(urbixxRouteFollowTimer);
    } catch (e2) {}
    urbixxRouteFollowTimer = 0;
    try {
      if (urbixxRouteRunnerMarker) urbixxRouteRunnerMarker.setMap(null);
    } catch (e3) {}
    urbixxRouteRunnerMarker = null;
    try {
      if (urbixxRunnerEl && urbixxRunnerEl.parentNode) urbixxRunnerEl.parentNode.removeChild(urbixxRunnerEl);
    } catch (e3b) {}
    urbixxRunnerEl = null;
    urbixxRunnerAngle = 0;
    try {
      if (urbixxRouteFinishMarker) urbixxRouteFinishMarker.setMap(null);
    } catch (e4) {}
    urbixxRouteFinishMarker = null;
    if (!keepRoute) {
      try {
        if (urbixxRoutePickupMarker) urbixxRoutePickupMarker.setMap(null);
      } catch (e5) {}
      urbixxRoutePickupMarker = null;
      try {
        if (urbixxRouteDropoffMarker) urbixxRouteDropoffMarker.setMap(null);
      } catch (e6) {}
      urbixxRouteDropoffMarker = null;
      try {
        if (urbixxRouteGlowPolyline) urbixxRouteGlowPolyline.setMap(null);
      } catch (e7) {}
      urbixxRouteGlowPolyline = null;
      try {
        if (urbixxRouteMainPolyline) urbixxRouteMainPolyline.setMap(null);
      } catch (e8) {}
      urbixxRouteMainPolyline = null;
    }
    urbixxClearRouteOverlay();
  }

  function urbixxHaversineMeters(a, b) {
    // a,b are google.maps.LatLng (or objects with lat()/lng())
    var R = 6371000;
    var lat1 = typeof a.lat === "function" ? a.lat() : a.lat;
    var lng1 = typeof a.lng === "function" ? a.lng() : a.lng;
    var lat2 = typeof b.lat === "function" ? b.lat() : b.lat;
    var lng2 = typeof b.lng === "function" ? b.lng() : b.lng;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLng = (lng2 - lng1) * Math.PI / 180;
    var s1 = Math.sin(dLat / 2);
    var s2 = Math.sin(dLng / 2);
    var q = s1 * s1 + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * s2 * s2;
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(q)));
  }

  function urbixxLatLngLerp(a, b, t) {
    var lat1 = typeof a.lat === "function" ? a.lat() : a.lat;
    var lng1 = typeof a.lng === "function" ? a.lng() : a.lng;
    var lat2 = typeof b.lat === "function" ? b.lat() : b.lat;
    var lng2 = typeof b.lng === "function" ? b.lng() : b.lng;
    return { lat: lat1 + (lat2 - lat1) * t, lng: lng1 + (lng2 - lng1) * t };
  }

  function urbixxBearingDeg(a, b) {
    // Return bearing in degrees from a->b
    var lat1 = (typeof a.lat === "function" ? a.lat() : a.lat) * Math.PI / 180;
    var lng1 = (typeof a.lng === "function" ? a.lng() : a.lng) * Math.PI / 180;
    var lat2 = (typeof b.lat === "function" ? b.lat() : b.lat) * Math.PI / 180;
    var lng2 = (typeof b.lng === "function" ? b.lng() : b.lng) * Math.PI / 180;
    var y = Math.sin(lng2 - lng1) * Math.cos(lat2);
    var x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1);
    var brng = Math.atan2(y, x) * 180 / Math.PI;
    // normalize 0..360
    brng = (brng + 360) % 360;
    return brng;
  }

  function urbixxOffsetLatLng(from, bearingDeg, meters) {
    // Move a lat/lng by `meters` along a bearing (degrees). Returns {lat,lng}
    var R = 6371000;
    var lat1 = (typeof from.lat === "function" ? from.lat() : from.lat) * Math.PI / 180;
    var lng1 = (typeof from.lng === "function" ? from.lng() : from.lng) * Math.PI / 180;
    var brng = (bearingDeg || 0) * Math.PI / 180;
    var d = (meters || 0) / R;

    var sinLat1 = Math.sin(lat1);
    var cosLat1 = Math.cos(lat1);
    var sinD = Math.sin(d);
    var cosD = Math.cos(d);

    var lat2 = Math.asin(sinLat1 * cosD + cosLat1 * sinD * Math.cos(brng));
    var lng2 = lng1 + Math.atan2(Math.sin(brng) * sinD * cosLat1, cosD - sinLat1 * Math.sin(lat2));

    var outLat = lat2 * 180 / Math.PI;
    var outLng = lng2 * 180 / Math.PI;
    // normalize to [-180, 180]
    outLng = ((outLng + 540) % 360) - 180;
    return { lat: outLat, lng: outLng };
  }

  function urbixxAngleLerp(current, target, t) {
    // shortest-path interpolation across 0/360 wrap
    var delta = ((target - current + 540) % 360) - 180;
    return (current + delta * t + 360) % 360;
  }

  function urbixxEnsureRunnerEl(mapEl) {
    try {
      var overlay = urbixxEnsureRouteOverlay(mapEl);
      if (!overlay) return null;
      if (urbixxRunnerEl && urbixxRunnerEl.parentNode === overlay) return urbixxRunnerEl;
      var img = document.createElement("img");
      img.className = "urbixx-route-runner";
      img.alt = "";
      img.decoding = "async";
      img.loading = "eager";
      img.src = URBIXX_TRACKING_ICON_URL;
      img.style.display = "none";
      overlay.appendChild(img);
      urbixxRunnerEl = img;
      return img;
    } catch (e) {
      return null;
    }
  }

  function urbixxSetRunnerPositionAndAngle(latLng, angleDeg, mapEl) {
    try {
      if (!urbixxOverlayView) return;
      var runner = urbixxEnsureRunnerEl(mapEl);
      if (!runner) return;
      var ll = latLng && latLng.lat ? latLng : new google.maps.LatLng(latLng.lat, latLng.lng);
      var pt = urbixxGetDivPixel(ll);
      if (!pt) {
        runner.style.display = "none";
        return;
      }
      runner.style.display = "block";
      runner.style.left = pt.x + "px";
      runner.style.top = pt.y + "px";
      urbixxRunnerAngle = urbixxAngleLerp(urbixxRunnerAngle, angleDeg, 0.22);
      runner.style.transform = "translate(-50%, -50%) rotate(" + urbixxRunnerAngle.toFixed(1) + "deg)";
    } catch (e) {}
  }

  function urbixxEnsureRunnerVisible(latLng, angleDeg, mapEl, attempt) {
    attempt = attempt || 0;
    try {
      urbixxSetRunnerPositionAndAngle(latLng, angleDeg, mapEl);
      if (urbixxRunnerEl && urbixxRunnerEl.style.display === "block") return;
    } catch (e) {}
    if (attempt >= 8) return;
    window.setTimeout(function() {
      urbixxEnsureRunnerVisible(latLng, angleDeg, mapEl, attempt + 1);
    }, 120);
  }
  function urbixxGetDivPixel(latLng) {
    try {
      if (!urbixxOverlayView) return null;
      var proj = urbixxOverlayView.getProjection && urbixxOverlayView.getProjection();
      if (!proj || !proj.fromLatLngToDivPixel) return null;
      return proj.fromLatLngToDivPixel(latLng);
    } catch (e) {
      return null;
    }
  }

  function urbixxConfettiAt(latLng, attempt) {
    try {
      if (!urbixxRouteOverlay) return;
      attempt = attempt || 0;
      // Wait a tick for projection to be available on some browsers
      var ptTry = urbixxGetDivPixel(latLng);
      if (!ptTry && attempt < 6) {
        return window.setTimeout(function() {
          urbixxConfettiAt(latLng, attempt + 1);
        }, 120);
      }
      urbixxClearRouteOverlay();
      var pt = ptTry;
      var x = pt ? pt.x : (urbixxRouteOverlay.clientWidth / 2);
      var y = pt ? pt.y : (urbixxRouteOverlay.clientHeight / 2);

      // finish pulse
      var pulse = document.createElement("div");
      pulse.className = "urbixx-finish-pulse";
      pulse.style.left = x + "px";
      pulse.style.top = y + "px";
      urbixxRouteOverlay.appendChild(pulse);

      // confetti pieces (black/white luxury)
      var pieces = 28;
      for (var i = 0; i < pieces; i++) {
        var p = document.createElement("span");
        p.className = "urbixx-confetti-piece";
        var angle = (Math.PI * 2) * (i / pieces);
        var spread = 70 + Math.random() * 70;
        var dx = Math.cos(angle) * spread;
        var dy = Math.sin(angle) * spread - (90 + Math.random() * 70);
        var rot = (Math.random() * 420 - 210) + "deg";
        p.style.left = x + "px";
        p.style.top = y + "px";
        p.style.setProperty("--dx", dx.toFixed(1) + "px");
        p.style.setProperty("--dy", dy.toFixed(1) + "px");
        p.style.setProperty("--rot", rot);
        // alternating monochrome tones
        p.style.background = (i % 3 === 0) ? "rgba(255,255,255,0.92)" : "rgba(15,15,15,0.92)";
        p.style.border = "1px solid rgba(0,0,0,0.08)";
        urbixxRouteOverlay.appendChild(p);
      }

      // cleanup
      window.setTimeout(function() {
        urbixxClearRouteOverlay();
      }, 1200);
    } catch (e) {}
  }

  function urbixxFlagIconSvg() {
    // clean black flag with subtle white stroke
    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54">' +
      '<defs><filter id="s" x="-50%" y="-50%" width="200%" height="200%"><feDropShadow dx="0" dy="8" stdDeviation="8" flood-color="#000" flood-opacity="0.25"/></filter></defs>' +
      '<g filter="url(#s)">' +
      '<circle cx="27" cy="27" r="14.5" fill="#0b0b0b" stroke="rgba(255,255,255,0.92)" stroke-width="2"/>' +
      '<path d="M26 20v15" stroke="rgba(255,255,255,0.92)" stroke-width="2.2" stroke-linecap="round"/>' +
      '<path d="M27 21c5 0 6 2 9 2-1 3-2 5-2 7-3 0-4-2-7-2" fill="rgba(255,255,255,0.92)"/>' +
      '</g></svg>';
    return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg);
  }

  function urbixxBadgeIconSvg(text) {
    var safe = String(text || "");
    // A premium pill label with small pointer. Black with subtle white border.
    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="160" height="56" viewBox="0 0 160 56">' +
      '<defs><filter id="s" x="-50%" y="-50%" width="200%" height="200%"><feDropShadow dx="0" dy="10" stdDeviation="10" flood-color="#000" flood-opacity="0.22"/></filter></defs>' +
      '<g filter="url(#s)">' +
      '<path d="M28 8h104a16 16 0 0 1 16 16v4a16 16 0 0 1-16 16H92l-12 10-12-10H28A16 16 0 0 1 12 28v-4A16 16 0 0 1 28 8z" fill="#0b0b0b" stroke="rgba(255,255,255,0.86)" stroke-width="2"/>' +
      '<text x="80" y="29" text-anchor="middle" font-family="Instrument Sans, Arial, sans-serif" font-size="16" font-weight="700" fill="rgba(255,255,255,0.96)">' +
      safe.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;") +
      '</text>' +
      '</g></svg>';
    return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg);
  }

  function urbixxRenderLuxuryRoute(result) {
    try {
      if (!result || !result.routes || !result.routes[0] || !urbixxMap) return;
      var route = result.routes[0];
      var path = route.overview_path || [];
      if (!path || path.length < 2) return;

      // clear previous
      try { if (urbixxRouteGlowPolyline) urbixxRouteGlowPolyline.setMap(null); } catch (e0) {}
      try { if (urbixxRouteMainPolyline) urbixxRouteMainPolyline.setMap(null); } catch (e1) {}
      try { if (urbixxRoutePickupMarker) urbixxRoutePickupMarker.setMap(null); } catch (e2) {}
      try { if (urbixxRouteDropoffMarker) urbixxRouteDropoffMarker.setMap(null); } catch (e3) {}
      urbixxRouteGlowPolyline = null;
      urbixxRouteMainPolyline = null;
      urbixxRoutePickupMarker = null;
      urbixxRouteDropoffMarker = null;

      // Luxury black line with soft glow
      urbixxRouteGlowPolyline = new google.maps.Polyline({
        path: path,
        strokeColor: "#0b0b0b",
        strokeOpacity: 0.18,
        strokeWeight: 14,
        clickable: false,
        zIndex: 1
      });
      urbixxRouteGlowPolyline.setMap(urbixxMap);

      urbixxRouteMainPolyline = new google.maps.Polyline({
        path: path,
        strokeColor: "#0b0b0b",
        strokeOpacity: 0.95,
        strokeWeight: 7,
        clickable: false,
        zIndex: 2
      });
      urbixxRouteMainPolyline.setMap(urbixxMap);

      // Premium pickup / drop-off labels
      var start = path[0];
      var end = path[path.length - 1];
      urbixxRoutePickupMarker = new google.maps.Marker({
        position: start,
        map: urbixxMap,
        icon: {
          url: urbixxBadgeIconSvg("Pickup"),
          scaledSize: new google.maps.Size(120, 42),
          anchor: new google.maps.Point(60, 40)
        },
        zIndex: 9000
      });

      urbixxRouteDropoffMarker = new google.maps.Marker({
        position: end,
        map: urbixxMap,
        icon: {
          url: urbixxBadgeIconSvg("Drop-off"),
          scaledSize: new google.maps.Size(132, 42),
          anchor: new google.maps.Point(66, 40)
        },
        zIndex: 9000
      });
    } catch (e) {
      // no-op
    }
  }

  function urbixxStartRouteAnimation(result, mapEl, opts) {
    try {
      if (!result || !result.routes || !result.routes[0] || !urbixxMap) return;
      opts = opts || {};
      // Default behaviour (first run after "Calculate fare"): cinematic close-up + camera follow.
      // Replay can pass { followCamera: false } to keep the current overview framing.
      var followCamera = (opts.followCamera !== false);
      var fitPadding = opts.fitPadding || { top: 60, right: 60, bottom: 60, left: 60 };

      var route = result.routes[0];
      var path = route.overview_path || [];
      if (!path || path.length < 2) return;

      // Only cancel animation artifacts; keep route line + labels
      urbixxCancelRouteAnimation({ keepRoute: true });
      urbixxEnsureRouteOverlay(mapEl);

      // OverlayView + overlay root are ensured by urbixxEnsureRouteOverlay()

      var start = path[0];
      var end = path[path.length - 1];

      // Finish flag marker (hidden until the end)
      urbixxRouteFinishMarker = new google.maps.Marker({
        position: end,
        map: null,
        icon: {
          url: urbixxFlagIconSvg(),
          scaledSize: new google.maps.Size(42, 42),
          anchor: new google.maps.Point(21, 21)
        },
        zIndex: 9999
      });

      // Runner marker (Urbixx tracking icon)
      // Use an HTML overlay runner so we can rotate the PNG to the route direction
      urbixxEnsureRunnerEl(mapEl);

      // Respect reduced motion
      if (urbixxPrefersReducedMotion()) {
        try { urbixxEnsureRunnerVisible(end, urbixxBearingDeg(path[path.length - 2], end), mapEl); } catch (e0) {}
        try { urbixxRouteFinishMarker.setMap(urbixxMap); } catch (e1) {}
        return;
      }

      // Duration based on requested speed: ~50 meters per second
      var totalMeters = 0;
      var seg = [];
      var cum = [0];
      for (var i = 0; i < path.length - 1; i++) {
        var m = urbixxHaversineMeters(path[i], path[i + 1]);
        seg.push(m);
        totalMeters += m;
        cum.push(totalMeters);
      }
      var durationMs = Math.round((totalMeters / 50) * 1000);
      // keep within reasonable bounds
      durationMs = Math.max(1600, Math.min(18000, durationMs));

      // Camera: cinematic close-up follow (optional), then fit bounds at end
      var savedCenter = urbixxMap.getCenter();
      var savedZoom = urbixxMap.getZoom();
      if (followCamera) {
        // Very close zoom (roughly ~50m per cm feeling on most screens)
        // Satellite with labels always on
        try { urbixxMap.setMapTypeId(google.maps.MapTypeId.HYBRID); } catch (e1z) {}
        try { urbixxMap.setZoom(20); } catch (e2) {}
        try { urbixxMap.setCenter(start); } catch (e3) {}
      }

      // Smooth camera follow (ease) - use setCenter interpolation for buttery motion
      var cam = {
        lat: (typeof start.lat === "function" ? start.lat() : start.lat),
        lng: (typeof start.lng === "function" ? start.lng() : start.lng)
      };

      var t0 = 0;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / durationMs);
        // Constant speed along the path (50 m/s), camera easing handles the luxury feel
        var dist = p * totalMeters;

        // find segment index
        var idx = 0;
        while (idx < cum.length - 1 && cum[idx + 1] < dist) idx++;
        var segStart = cum[idx];
        var segLen = seg[idx] || 1;
        var localT = (dist - segStart) / segLen;
        if (localT < 0) localT = 0;
        if (localT > 1) localT = 1;

        var posLL = urbixxLatLngLerp(path[idx], path[idx + 1], localT);
        var bearing = urbixxBearingDeg(path[idx], path[idx + 1]);
        // Projection may not be ready on the first frames; keep trying until it is.
        try { urbixxEnsureRunnerVisible(posLL, bearing, mapEl); } catch (e4) {}

        if (followCamera) {
          // Camera ease follow (no panTo spam)
          try {
            // Look-ahead camera: keep the runner lower in frame by aiming slightly ahead
            var leadBase = Math.min(140, Math.max(60, totalMeters * 0.02)); // ~60-140m
            var leadScale = p < 0.9 ? 1 : Math.max(0, (1 - p) / 0.1); // fade lead near arrival
            var target = leadScale > 0 ? urbixxOffsetLatLng(posLL, bearing, leadBase * leadScale) : posLL;
            cam = urbixxLatLngLerp(cam, target, 0.14);
            urbixxMap.setCenter(cam);
          } catch (e5) {}
        }

        if (p < 1) {
          urbixxRouteAnimRaf = requestAnimationFrame(step);
        } else {
          // end state
          try { urbixxEnsureRunnerVisible(end, urbixxBearingDeg(path[path.length - 2], end), mapEl); } catch (e7) {}
          try {
            // swap drop-off label to finish flag for a "destination reached" moment
            if (urbixxRouteDropoffMarker) urbixxRouteDropoffMarker.setMap(null);
          } catch (e8a) {}
          try { urbixxRouteFinishMarker.setMap(urbixxMap); } catch (e8) {}
          window.setTimeout(function() {
            urbixxConfettiAt(end);
          }, 120);
          // restore a comfortable route view (only when following camera)
          if (followCamera) {
            try {
              if (route.bounds) {
                urbixxMap.fitBounds(route.bounds, fitPadding);
              } else {
                urbixxMap.setCenter(savedCenter);
                urbixxMap.setZoom(savedZoom);
              }
            } catch (e9) {}
          }
        }
      }

      urbixxRouteAnimRaf = requestAnimationFrame(step);
    } catch (e) {
      // no-op
    }
  }

  function urbixxShowRoute(pickupAddress, dropoffAddress) {
    if (!window.google || !google.maps) {
      console.warn("Google Maps is not available");
      return;
    }

    var panel = document.getElementById("urbixx-map-panel");
    var mapEl = document.getElementById("urbixx-map");
    var closeBtn = document.getElementById("urbixx-map-close");
    var showMapBtn = document.getElementById("urbixx-show-map-btn");
    var ctlPickupBtn = document.getElementById("urbixx-map-show-pickup");
    var ctlDropoffBtn = document.getElementById("urbixx-map-show-dropoff");
    var ctlReplayBtn = document.getElementById("urbixx-map-replay");
    var contTopBtn = document.getElementById("urbixx-map-continue-top");
    var contBottomBtn = document.getElementById("urbixx-map-continue-bottom");

    if (!panel || !mapEl) return;

    if (!urbixxMap) {
      urbixxMap = new google.maps.Map(mapEl, {
        zoom: 10,
        center: { lat: 52.0907, lng: 5.1214 },
        disableDefaultUI: false,
        // Satellite imagery + labels always visible
        mapTypeId: google.maps.MapTypeId.HYBRID,
        styles: [{ elementType: "labels", stylers: [{ visibility: "on" }] }]
      });

      urbixxDirectionsService = new google.maps.DirectionsService();
      urbixxDirectionsRenderer = new google.maps.DirectionsRenderer({
        map: urbixxMap,
        suppressMarkers: true,
        suppressPolylines: true
      });

      if (closeBtn) {
        closeBtn.addEventListener("click", function() {
          panel.classList.remove("urbixx-open");
          panel.setAttribute("aria-hidden", "true");
          // Keep route visible for quick re-open via "Show map"
          urbixxCancelRouteAnimation({ keepRoute: true });
          try { if (showMapBtn) showMapBtn.textContent = "Show map"; } catch (eTxt) {}
        });
      }
    }

    urbixxDirectionsService.route(
      {
        origin: pickupAddress,
        destination: dropoffAddress,
        travelMode: google.maps.TravelMode.DRIVING
      },
      function(result, status) {
        if (status === "OK" && result) {
          // New route: clear previous route + animation completely first
          urbixxCancelRouteAnimation({ keepRoute: false });
          urbixxDirectionsRenderer.setDirections(result);
          panel.classList.add("urbixx-open");
          panel.setAttribute("aria-hidden", "false");
          urbixxLastRouteResult = result;

          // Enable bottom controls and external "Show map" button
          try {
            if (ctlPickupBtn) ctlPickupBtn.disabled = false;
            if (ctlDropoffBtn) ctlDropoffBtn.disabled = false;
            if (ctlReplayBtn) ctlReplayBtn.disabled = false;
          } catch (eCtl) {}
          try {
            if (showMapBtn) {
              showMapBtn.style.display = "inline-flex";
              showMapBtn.disabled = false;
              showMapBtn.textContent = "Close map";
            }
          } catch (eShow) {}
          try {
            if (contTopBtn) contTopBtn.disabled = false;
            if (contBottomBtn) contBottomBtn.disabled = false;
          } catch (eCont) {}

          // Luxury route rendering: thick black line + soft glow, with premium labels
          try {
            urbixxRenderLuxuryRoute(result);
          } catch (eLux) {}

          // Premium route runner animation + finish confetti
          try {
            urbixxStartRouteAnimation(result, mapEl);
          } catch (eAnim) {}

          try {
            var route = result.routes[0];
            var leg = route.legs[0];
            var totalMeters = 0;
            var highwayMeters = 0;
            var highwayNames = [];

            leg.steps.forEach(function(step) {
              var dist = step.distance && step.distance.value ? step.distance.value : 0;
              totalMeters += dist;
              var html = step.html_instructions || "";
              var clean = html.replace(/<[^>]+>/g, "");
              var isHighway =
                /\bA\d+\b/i.test(clean) ||
                /motorway|highway|snelweg/i.test(clean);

              if (isHighway) {
                highwayMeters += dist;
                var matches = clean.match(/\bA\d+\b/gi);
                if (matches) {
                  matches.forEach(function(m) {
                    var up = m.toUpperCase();
                    if (highwayNames.indexOf(up) === -1) {
                      highwayNames.push(up);
                    }
                  });
                }
              }
            });

            var ratio = totalMeters ? highwayMeters / totalMeters : 0;
            var typeText;
            if (ratio > 0.6) {
              typeText = "Mostly highway route";
            } else if (ratio < 0.3) {
              typeText = "City route with more traffic lights";
            } else {
              typeText = "Mixed city and highway route";
            }

            var roadsText = "";
            if (highwayNames.length > 0) {
              roadsText = " via " + highwayNames.join(", ");
            }

            lastRouteSummaryText = typeText + roadsText;
          } catch (e) {
            console.warn("Could not build route summary", e);
            lastRouteSummaryText = "Fastest route calculated for your pickup and drop-off.";
          }
        } else {
          console.warn("Directions request failed:", status);
        }
      }
    );
  }

  
// ---- Multi-step + booking logic ----
